import type { ReactNode } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AuctionsScreen } from '../features/auctions/AuctionsScreen'
import { CollectionScreen } from '../features/catalog/CollectionScreen'
import { CollectionsScreen } from '../features/catalog/CollectionsScreen'
import { ForumScreen } from '../features/forum/ForumScreen'
import { LoginScreen } from '../features/auth/LoginScreen'
import { MatchingScreen } from '../features/matching/MatchingScreen'
import { MessagesScreen } from '../features/messages/MessagesScreen'
import { MyCollectionScreen } from '../features/inventory/MyCollectionScreen'
import { ProfileScreen } from '../features/profile/ProfileScreen'
import { Shell, Splash } from './Shell'
import { ShopScreen } from '../features/shop/ShopScreen'
import { TradeDetailScreen } from '../features/trades/TradeDetailScreen'
import { TradesScreen } from '../features/trades/TradesScreen'
import { useApp } from '../state/AppState'

export function App(): ReactNode {
  const app = useApp()

  if (app.isBootstrapping) return <Splash />

  return (
    <Routes>
      <Route element={<Shell />}>
        {/* Каталог открыт гостям: по нему решают, стоит ли
            регистрироваться. Личные разделы — под условием. */}
        <Route path="/collections" element={<CollectionsScreen />} />
        <Route
          path="/collections/:slug"
          element={<CollectionScreen />}
        />
        <Route path="/auctions" element={<AuctionsScreen />} />
        <Route path="/shop" element={<ShopScreen />} />
        <Route path="/forum" element={<ForumScreen />} />

        {app.isAuthenticated ? (
          <>
            <Route path="/my" element={<MyCollectionScreen />} />
            <Route path="/matching" element={<MatchingScreen />} />
            <Route path="/trades" element={<TradesScreen />} />
            <Route path="/trades/:id" element={<TradeDetailScreen />} />
            <Route path="/messages" element={<MessagesScreen />} />
            <Route path="/profile" element={<ProfileScreen />} />
          </>
        ) : (
          <Route path="/login" element={<LoginScreen />} />
        )}

        <Route
          path="*"
          element={<Navigate to="/collections" replace />}
        />
      </Route>
    </Routes>
  )
}
